import React, { useEffect, useState } from 'react'
import { m } from 'framer-motion'

export default function AnimatedCounter({ end, duration = 2, prefix = "", suffix = "", className = "" }) {
  const [displayValue, setDisplayValue] = useState(0)
  const [hasAnimated, setHasAnimated] = useState(false)

  useEffect(() => {
    if (hasAnimated) return

    let startTime = null
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime
      const progress = Math.min((currentTime - startTime) / (duration * 1000), 1)
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      const current = Math.floor(easeOutQuart * end)
      
      setDisplayValue(current)
      
      if (progress < 1) {
        requestAnimationFrame(animate)
      } else {
        setDisplayValue(end)
        setHasAnimated(true)
      }
    }
    
    // Small delay to ensure component is visible
    const timeout = setTimeout(() => {
      requestAnimationFrame(animate)
    }, 100)
    
    return () => clearTimeout(timeout)
  }, [end, duration, hasAnimated])

  return (
    <m.div
      className={className}
      initial={{ opacity: 0, scale: 0.5 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      onViewportEnter={() => {
        if (!hasAnimated) {
          setHasAnimated(true)
        }
      }}
    >
      <span className="text-5xl md:text-4xl font-bold text-white">{prefix}{displayValue.toLocaleString()}{suffix}</span>
    </m.div>
  )
}

